export default "__VITE_ASSET__FT4s9m2K__"